export default __webpack_public_path__ + "static/media/JavaScript - Algoritmos y Estructura de Datos - Freecodecamp.775b13b8.png";